import SchoolOptionsAdapter from './base';

export default class Group extends SchoolOptionsAdapter {
  modelNamePlural = 'optionGroups';

  pathForType(type) {
    type = type.replace(/^school-options\/group/, 'schema/optiongroups');
    return type;
  }
}
